import { Component, OnInit, Input, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderModel } from 'src/app/store/order/model';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants/app-constants';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderFacade } from 'src/app/store/order/facade';
import { ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from 'src/app/core/infrastructure/linq';
import { ServiceCatalogFacade } from 'src/app/store/self-diagnostic/service-catalog/facade';

@Component({
  selector: 'app-order-detail-for-grid',
  templateUrl: './order-detail-for-grid.component.html',
  styleUrls: ['./order-detail-for-grid.component.scss'],
  host: {
    class: 'd-block',
  },
  standalone: false,
})
export class OrderDetailForGridComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);

  @Input() order: OrderModel;
  @Input() categoryName: string;

  public isUkLanguage: boolean;

  public service: ServiceModel;

  ngOnInit(): void {
    this.isUkLanguage = this.translate.currentLang == AppConstants.LANGUAGE_UK;

    this.serviceCatalogFacade.entities$.subscribe(s$ => {
      let services = new List<ServiceModel>(s$);

      if (services.Any()) {
        this.service = services.FirstOrDefault(s => s.code == this.order.task.id && s.category.code == this.order.service.id);
      }
    });
  }

  goToOrder(order: OrderModel) {
    this.router.navigate(['/orders/order', order.id]);
  }

  onCopyId(orderId: number) {
    this.copyToClipboard(`${window.location.origin}/orders/order/${orderId}`);
  }

  copyToClipboard(item) {
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', item);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }

  getServiceName(): string {
    let serviceName: string;

    if (this.order && this.order.id) {
      serviceName = this.order.task?.value;
    }

    if (this.service) {
      if (this.isUkLanguage) {
        serviceName = this.service.nameUa;
      } else {
        serviceName = this.service.nameRu;
      }
    }

    return serviceName;
  }
}
